export const dateTimeFormats = {
  short: {
    month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  medium: {
    year: 'numeric', month: 'short', day: 'numeric'
  },
  long: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  full: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
  }
};

export const messages = {
    "login.form.title": "Bejelentkezés",
    "login.form.hint.user": "Felhasználónév",
    "login.form.hint.password": "Jelszó",
    "login.form.checkbox.remember-me": "Emlékezzen rám",
    "login.form.button.sign-in": "Bejelentkezés",
    "login.form.message.invalid-user-credentials": "A felhasználónév vagy jelszó helytelen",
    "login.form.message.user-required": "Felhasználónév beírása",
    "login.form.message.password-required": "Jelszó beírása",
    "login.form.button.forgot-password": "Elfelejtett jelszó?",
    "error.root-admin-login.title": "403-as hiba: hozzáférés letiltva",
    "error.root-admin-login.message": "Csak olvasásra jogosult adminisztrátorként jelentkezett be. A Web Recovery-konzol használatához az ügyfélbérlő felhasználójaként vagy adminisztrátoraként kell bejelentkeznie."
};
